import { AbstractSpecification } from '../../../../utils/specification/specification';
import { ProductPriceCardItem } from '../models/product-price-card-item.model';

export class PriceCustomerProductReferenceSpecification extends AbstractSpecification<ProductPriceCardItem> {
   constructor(private search: string, private regex: RegExp) {
      super();
   }

   isSatisfiedBy = (candidate: ProductPriceCardItem | undefined): boolean => {
      if (candidate === undefined) return false;
      if (!candidate.quotationLines || candidate.quotationLines.length === 0) return false;

      const references = candidate.quotationLines.map((line) => line.customerProductReference);
      return !!references.find((el) => el && el.toLowerCase().replace(this.regex, '').includes(this.search));
   };
}
